import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import '../../styles/Footer.css';
import logo from '../../assets/images/logo/logo.png';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <img src={logo} alt="IB Neubaur GmbH" height="60" />
            </div>
            <p>Fachplanung Elektrotechnik</p>
            <p>Geschäftsführer: Gerhard&nbsp;Neubaur</p>

          </div>
          
          <div className="footer-section">
            <h3>Standorte</h3>
            <div className="location">
              <h4><FontAwesomeIcon icon={faMapMarkerAlt} /> Rain am Lech (Hauptstandort)</h4>
              <p>Nelkenweg 6a</p>
              <p>86641 Rain am Lech</p>
            </div>

            <div className="location">
              <h4><FontAwesomeIcon icon={faMapMarkerAlt} /> Marxheim</h4>
              <p>Bayernstraße 20</p>
              <p>86688 Marxheim</p>
            </div>

            <div className="location">
              <h4><FontAwesomeIcon icon={faMapMarkerAlt} /> Ingolstadt</h4>
              <p>Geyer-Straße 7</p>
              <p>85055 Ingolstadt</p>
            </div>
          </div>
          
          <div className="footer-section">
            <h3>Navigation</h3>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/elektrotechnik">Elektrotechnik</Link></li>
              <li><Link to="/energietechnik">Energietechnik</Link></li>
              <li><Link to="/foerdertechnik">Fördertechnik</Link></li>
              <li><Link to="/iuk">IuK</Link></li>
              <li><Link to="/sicherheitstechnik">Sicherheitstechnik</Link></li>
              <li><Link to="/hls">HLS</Link></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h3>Über uns</h3>
            <ul className="footer-links">
              <li><Link to="/ueber-uns">Über uns</Link></li>
              <li><Link to="/software">Software & Tools</Link></li>
              <li><Link to="/bim">BIM</Link></li>
              <li><Link to="/denkmalschutz">Denkmalschutz</Link></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h3>Rechtliches</h3>
            <ul className="footer-links">
              <li><Link to="/impressum">Impressum</Link></li>
              <li><Link to="/datenschutz">Datenschutz</Link></li>
              <li><Link to="/agb">AGB</Link></li>
              <li>
                <button
                  type="button"
                  className="footer-link-button"
                  onClick={() =>
                    window.dispatchEvent(new CustomEvent('open-cookie-settings'))
                  }
                >
                  Cookie-Einstellungen
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} IB Neubaur GmbH. Alle Rechte vorbehalten.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;